import { Box } from "@mui/system";

export interface TableWithControlsWrapperProps {
    children: React.ReactNode;
}

function TableWithControlsWrapper(props: TableWithControlsWrapperProps) {
    return (
        <Box
            sx={(theme) => ({
                gap: "24px",
                display: "flex",
                flexDirection: "column",
                borderColor: theme.palette.primary.dark,
                textAlign: "center",
                "& .MuiChip-root": {
                    outline: "none",
                    backgroundColor: "rgba(0, 0, 0, 0.08)",
                },
            })}
        >
            {props.children}
        </Box>
    );
}

export default TableWithControlsWrapper;
